import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { NAVIGATION_ITEMS } from './navigation-items';
import { NavigationItemModel, IconType } from './navigation-item.model';
import { NavigationService } from '../../../../service/services/misc/navigation/navigation.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PopoverComponent } from '@fundamental-ngx/core/popover';
import { SwaService } from '../../../../service/services/misc/swa/swa.service';
import { ConfirmationDialogService } from '../../../../extension/cloud-automation-designer/services/confirmation-dialog.service';
import { LeaveConfirmationService } from '../../../../extension/product-blueprint-modeler/services/leave-confirmation.service';
import {Utils} from "../../../helpers/Utils";

@Component({
    selector: 'app-side-navigation',
    templateUrl: './side-navigation.component.html',
    styleUrls: ['./side-navigation.component.scss'],
    standalone: false
})
export class SideNavigationComponent implements OnDestroy {
    IconType = IconType;
    isOpen = false;
	@Input() condensed = true;
	@Output() condensedChange = new EventEmitter<boolean>();

	@ViewChild('orgSelection')
	    orgSelection: PopoverComponent;

	sideNavMain: NavigationItemModel[] = Utils.isPrivateCloud ? [NAVIGATION_ITEMS[0]]: NAVIGATION_ITEMS;


	subscriptions: Subscription[] = [];

	constructor(
		private navigationService: NavigationService,
		public location: Location,
		private route: ActivatedRoute,
		private router: Router,
		private _swaService: SwaService,
		private confirmationDialogService: ConfirmationDialogService,
		private leaveConfirmationService: LeaveConfirmationService
	) {
	    this.subscriptions.push(this.subscribeToUrlChange());
	}

	subscribeToUrlChange() {
	    return this.navigationService.getNavigationEvents(this.route).subscribe(() => {
	        this.updateNavigationEntries(this.location.path());
	    });
	}

	onPageClick(page: string): void {
	    if (this.router.url.includes('cloudAutomationDesigner/designer')) {
	        this.confirmationDialogService.openLeaveCADConfirmation(() => this.navigationService.navigateToPage(page));
	        return;
	    }
	    if (this.router.url.includes('productBlueprintModeler/designer')) {
	        this.leaveConfirmationService.request(() => this.navigationService.navigateToPage(page));
	        return;
	    }
	    this._swaService.sendCustomEvent(this._swaService.SWA_EVENT_TYPES.SIDE_PAGE_CLICK, [page], []);
	    this.condensedChange.emit(true);
	    this.navigationService.navigateToPage(page);
	}

	updateNavigationEntries(currentPath: string) {
	    this.sideNavMain.forEach((item) => {
	        item.isSelected = currentPath.startsWith(`/${item.route}`);
	    });
	}

	ngOnDestroy(): void {
	    this.subscriptions.forEach((s) => s.unsubscribe());
	}

	protected readonly window = window;
}
